import React, { useEffect, useState, useMemo } from "react"
import { Box, BoxProps } from "@material-ui/core"
import { loadCss } from "esri-loader"

import { useMapView } from "./MapProvider"
import { useEsriModules } from "./useEsriModules"

loadCss()

export const WebMapView: React.FC<BoxProps &
  __esri.MapViewProperties &
  __esri.WebMapProperties> = ({
  center = [144.9631, -37.8136],
  zoom = 15,
  /** Array of layers to add by default. Memoise this to prevent unecessary re-renders */
  layers = [],
  ...props
}) => {
  /** Get the dispatcher to hoist the view to the context */
  const { setView } = useMapView()

  /** Get esri modules */
  const [MapView, WebMap] = useEsriModules([
    "esri/views/MapView",
    "esri/WebMap",
  ])

  const view = useMemo(() => MapView && new MapView(), [MapView])

  /** When the ref becomes available, create the map view */
  const [container, setContainer] = useState<HTMLDivElement | null>(null)
  const mapArgs = JSON.stringify({ center, zoom })
  useEffect(() => {
    if (view && container && MapView && WebMap) {
      const args = JSON.parse(mapArgs)
      const map = new WebMap()
      view.container = container
      view.map = map
      for (const key in args) {
        view[key] = args[key]
      }
      setView(view)
    }
  }, [container, setView, MapView, WebMap, mapArgs, view])

  /** Listen for layers and add them */
  useEffect(() => {
    if (view?.map) {
      layers.forEach(layer => {
        if (
          !view.map.allLayers.items.find((l: __esri.Layer) => l.id === layer.id)
        ) {
          view.map.add(layer)
        }
      })
    }
  }, [view, layers])

  return (
    <Box
      flexGrow={1}
      height={1}
      width={1}
      // @ts-ignore
      ref={setContainer}
      {...props}
    />
  )
}

// @ts-ignore
WebMapView.whyDidYouRender = true
